import EventEmitter from 'events';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { PREROLL_SLOT_NAME, VIDEO_MEDIUM, partialGamVideoPrerollSlot, } from '../../js/ads/constants';
import configUtils from '../../js/utils/configUtils';
import getAdTypeControllerFromFormat from '../../js/utils/getAdTypeControllerFromFormat';
import { getExperiment } from '../../js/utils/getExperiment';
import { isAdSlotVisible } from '../../js/utils/htmlUtils';
import logger from '../logging/logger';
import SlotEvents from './slotEvents';
function getGamVideoPrerollSlot(prerollAdSlot) {
    const { elementId, name, formats } = prerollAdSlot;
    const isAlwaysTryAudioAfterVideoOnlyEnabled = getExperiment('ads.video.preroll.newFlow.alwaysTryAudio.enabled');
    const slot = {
        ...buildAdSlot(elementId, name, formats),
        ...(isAlwaysTryAudioAfterVideoOnlyEnabled && { nextSlot: prerollAdSlot }),
    };
    slot.setNextSlot = function () {
        if (!this.nextSlot) {
            this.nextSlot = prerollAdSlot;
        }
    };
    const transformedFormats = slot.formats.map((format) => {
        const { companions, ...rest } = format;
        return {
            ...rest,
            ...partialGamVideoPrerollSlot,
            adUnitId: getExperiment('ads.video.preroll.adUnitId'),
        };
    });
    return {
        ...slot,
        medium: VIDEO_MEDIUM,
        formats: transformedFormats,
        formatDefinition: transformedFormats[0],
    };
}
function buildAdSlot(elementId, name, formats) {
    const emitter = new EventEmitter();
    const formatsArray = Array.isArray(formats) ? formats : [formats];
    const [formatDefinition] = formatsArray;
    return {
        elementId,
        name,
        formats: formatsArray,
        formatDefinition,
        medium: formatDefinition?.medium,
        adTypeController: getAdTypeControllerFromFormat(formatDefinition),
        isAdSlotVisible: () => isAdSlotVisible(elementId),
        refresh() {
            emitter.emit(SlotEvents.refresh, {});
        },
        on: emitter.on.bind(emitter),
        once: emitter.once.bind(emitter),
        off: emitter.removeAllListeners.bind(emitter),
    };
}
const adSlotFactory = {
    createAdSlot(slotName, elementId, dimensions) {
        const slot = configUtils.getSlotDefinition(slotName);
        const formats = cloneDeep(configUtils.getFormatDefinitionsBySlotDefinition(slot));
        const filteredFormats = configUtils.filterFormatDefinitionsByDimensions(formats, dimensions);
        logger.info({
            message: 'adSlotFactory.createAdSlot.debug.dimensions.issue',
            data: {
                slotNameParam: slotName,
                dimensionsParam: dimensions,
                formats: formats?.map((item) => ({
                    dimensions: item.dimensions,
                })),
            },
        });
        if (!(slot && filteredFormats) || isEmpty(filteredFormats)) {
            return null;
        }
        const adSlot = buildAdSlot(elementId, slot.name, filteredFormats);
        if (adSlot.name === PREROLL_SLOT_NAME &&
            getExperiment('ads.video.preroll.newFlow.enabled')) {
            return getGamVideoPrerollSlot(adSlot);
        }
        return adSlot;
    },
};
export default adSlotFactory;
